<script>
export default {
	components: {},
	data() {
		return {
			googlePassword: null,
			activationDisabled: true,
			errors: false
		}
	},
	mounted() {

		$('#googleAuthModal').modal('toggle');

		this.$refs.google_key.focus();

		this.$watch('googlePassword', (val) => {

			if (val.toString().length == 6) {

				this.activationDisabled = true;

				this.login();

			} else {
				this.activationDisabled = false;
			}

		});

	},
	methods: {
		async login() {

			this.errors = false;

			await axios.post('/auth/google', {google_password: this.googlePassword}).then(response => {

				this.errors = false;

				window.location = '/';

			}).catch(error => {

				this.errors = true;
				this.googlePassword = '';

			});

		}
	}
}
</script>